<script lang="ts">
    import { onMount } from 'svelte';
    import { get } from 'svelte/store';
    import { verifyMagicLink, resendMagicLink } from '../lib/auth';
    import { _ } from 'svelte-i18n';
    import { auth } from '../lib/auth';
    import { buildRedirectUrl } from '../lib/utils';
    import { refreshSettings } from '../stores/settings';

    let error: string | null = null;
    let loading = true;

    onMount(async () => {
 
        // Extract the token and get the magic link information, including the target url
        const paramsString = window.location.hash.split('/verify?')[1] || '';
        const params = new URLSearchParams(paramsString);
        const token = params.get('token');
        
        if (!token) {
            // Show error
            error = $_('verify.noToken');
            loading = false;
            return;
        }

        let result: any;
        try {
            result = await verifyMagicLink(token);
        } catch (e) {
            console.error('Magic link verification failed:', e);
            error = $_('verify.invalidToken');
            loading = false;
            return;
        }
        
        let returnTo = result.return_to || '/game-assist/';
        const redirectInfo = buildRedirectUrl(returnTo);

        // 1. Check for active session, if found redirect
        const authState = get(auth);

        if (authState.token) {
            
            // we store the full active user information (including teams) in settings store, so that needs to be refreshed when we are setting a new token
            refreshSettings();

            // If auth is still loading (user fetch in progress), wait for it
            if (authState.loading || authState.user === null) {
                console.log('auth is still loading, waiting for it to complete');
                try {
                    await auth.fetchUser();
                    // After fetching, check again
                    const updatedAuthState = get(auth);
                    if (updatedAuthState.user) {
                        console.log('user is logged in, redirecting to returnTo', redirectInfo.fullUrl);
                        window.location.href = redirectInfo.fullUrl;
                        return;
                    }
                } catch (error) {
                    console.log('Failed to fetch user, continuing with verification');
                    // Continue with normal verification flow if user fetch fails
                }
            } else if (authState.user) {
                // User is already loaded and authenticated
                console.log('user is logged in, redirecting to returnTo', redirectInfo.fullUrl);
                window.location.href = redirectInfo.fullUrl;
                return;
            }
        }

        // 2. No active session, check the magic link result

        try {
            // 1. Check if the magic link is expired but can be resend, 
            if (result.resend) {
                // console.log('magic link is expired but can be resend, resending it');
                await resendMagicLink(token);
                // show a message that a new link has been sent
                error = $_('verify.linkResent');
                loading = false;
                 // automatically redirect to login after 5 seconds to avoid sending new links on page reload
                setTimeout(() => {
                    window.location.href = '/account/#/login';
                }, 5000);
                return;
            }
            
            // 2. Normal flow - token is valid
            await auth.fetchUser();
            // console.log('using magic link to set token');
            window.location.href = redirectInfo.fullUrl;

        } catch (e) {
            console.error('Verification error:', e);
            error = $_('verify.invalidToken');
        } finally {
            loading = false;
        }

    });
</script>

<div class="container">
    {#if loading}
        <p>{$_('verify.verifying')}</p>
    {:else if error}
        <p class="error">{error}</p>
        <a href="/account/#/login">{$_('verify.returnToLogin')}</a>
    {/if}
</div> 